import React, { createContext, useContext, useEffect, useState } from 'react';

const CartCtx = createContext(null);
const STORAGE = 'gifts_gt_cart';

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE) || '[]'); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      const effectivePrice = product.is_offer && product.offer_price ? product.offer_price : product.price;
      if (existing) {
        return prev.map((i) => i.id === product.id ? { ...i, qty: Math.min(i.qty + qty, product.stock) } : i);
      }
      return [...prev, {
        id: product.id,
        name: product.name,
        price: effectivePrice,
        image: product.image,
        stock: product.stock,
        qty: Math.min(qty, product.stock),
      }];
    });
    setOpen(true);
  };

  const updateQty = (id, qty) => {
    setItems((prev) => prev.map((i) => i.id === id ? { ...i, qty: Math.max(1, Math.min(qty, i.stock)) } : i));
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, addItem, updateQty, removeItem, clear, total, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
